export default {
  add_rate: 'Satz hinzufügen',
  remove_rate: 'Satz entfernen',
  gateways: {
    adyen: 'Adyen',
  },
  methods: {
    fallback: 'Alle Zahlungsarten',
    card: 'Karte',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    link: 'Link',
    paypal: 'PayPal',
    pay_by_bank: 'Pay by Bank',
    sepa_debit: 'SEPA-Lastschrift',
    sofort: 'Sofort',
    giropay: 'giropay',
    bacs_debit: 'Bacs-Lastschrift',
    stripe_other: 'Andere Stripe-Zahlungsarten',
  },
  fields: {
    percentage: 'Prozentsatz',
    fixed: 'Festbetrag',
    min: 'Mindestbetrag',
  },
  explanation: {
    none: 'Für {{method}} wird noch nichts berechnet — diese Zahlungen erzielen 0 % Marge, bis ein Satz gesetzt ist.',
    floor_only: 'Bei {{method}} beträgt die Verarbeitungsgebühr {{floor}} pro Zahlung, unabhängig vom Bestellwert.',
    percentage: 'Bei {{method}} beträgt die Verarbeitungsgebühr {{percentage}} % des Bestellwerts.',
    percentage_floor:
      'Bei {{method}} beträgt die Verarbeitungsgebühr {{percentage}} % des Bestellwerts, mindestens jedoch {{floor}}.',
    fixed: 'Bei {{method}} beträgt die Verarbeitungsgebühr {{fixed}} pro Zahlung.',
    fixed_floor: 'Bei {{method}} beträgt die Verarbeitungsgebühr {{fixed}} pro Zahlung, mindestens jedoch {{floor}}.',
    combined: 'Bei {{method}} beträgt die Verarbeitungsgebühr {{fixed}} fest plus {{percentage}} % des Bestellwerts.',
    combined_floor:
      'Bei {{method}} beträgt die Verarbeitungsgebühr {{fixed}} fest plus {{percentage}} % des Bestellwerts, mindestens jedoch {{floor}}.',
    redundant_floor:
      'Der Mindestbetrag von {{floor}} greift nie — der Festbetrag erreicht ihn bereits bei jeder Zahlung. Setzen Sie ihn über {{fixed}} oder entfernen Sie ihn.',
  },
  example: 'Beispiel: Bei einer Bestellung über {{total}} beträgt die Verarbeitungsgebühr {{fee}}.',
};
